import React, { JSX } from 'react';
import { Flex, useBreakpointValue } from '@chakra-ui/react';
import { VStack } from 'components/ui';
import HeaderNav from './HeaderNav/HeaderNav';

const DEFAULT_MAX_WIDTH_PX = '1024px';

type Props = {
  leftChildren: JSX.Element;
  maxWidth?: string;
  rightChildren: JSX.Element;
  // default is true
  showHeader?: boolean;
};

export const TwoColsLayout = ({
  leftChildren,
  maxWidth = DEFAULT_MAX_WIDTH_PX,
  rightChildren,
  showHeader = true,
}: Props) => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  });

  return (
    <>
      {showHeader && <HeaderNav />}

      <Flex
        // mx="auto" centers in normal document flow (e.g. /eligibility as a
        // route root). alignSelf alone only works when a parent is flex.
        alignSelf={isMobile ? undefined : 'center'}
        flex={1}
        flexDirection={isMobile ? 'column' : 'row'}
        h="100%"
        maxW={isMobile ? undefined : maxWidth}
        mx={isMobile ? undefined : 'auto'}
        w="100%"
        // Do NOT use zIndex={-1} here. A negative z-index on this Flex
        // pulls the whole layout behind its parent stacking context
        // (e.g. Form's `.form-container`), so controls become unclickable
        // and never show a pointer cursor.
        // @ts-ignore
        gap={isMobile ? undefined : '200px'}
      >
        {/*
          minW={0} lets columns shrink below intrinsic content width so a
          wide testimonial/image doesn't force horizontal overflow.
          zIndex on the left keeps form controls clickable if the right
          column still overlaps (later flex siblings paint on top).
        */}
        <VStack
          flex={1}
          minW={0}
          pl={isMobile ? undefined : 4}
          position="relative"
          zIndex={1}
        >
          {leftChildren}
        </VStack>

        <VStack
          alignItems={isMobile ? 'center' : undefined}
          alignSelf={isMobile ? 'center' : 'stretch'}
          flex={1}
          minW={0}
          mx={-4}
          w={isMobile ? '100%' : undefined}
        >
          {rightChildren}
        </VStack>
      </Flex>
    </>
  );
};
